import { createAction, createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

import getRandom from '../util/getRandom';

const INITIAL_STATE = Immutable({
  checklists: [],
  checklistToDos: [],
  checklistRuns: [],
  checklistDueDates: null,
  dueGroup: null,
  isLoading: false,
  isLoadingSearchResults: false,
  selectedChecklist: null,
  selectedChecklistId: null,
  selectedChecklistRun: null,
  completedDialogOpen: false,
  searchResults: [],
  searchTerm: '',
  score: 0,
});

// api actions
export const onLoadChecklists = createAction('ONLOAD_CHECKLISTS');

// utils
export const onLoadChecklistsFailed = createAction('ONLOADCHECKLISTSFAILED');
export const onLoadChecklistsSucceeded = createAction(
  'ONLOADCHECKLISTSSUCCEEDED'
);

//checklistRuns
export const onLoadChecklistRuns = createAction('ON_LOAD_CHECKLIST_RUNS');
export const onLoadChecklistRunsFailed = createAction(
  'ONLOADCHECKLISTRUNSFAILED'
);
export const onLoadChecklistRunsSucceeded = createAction(
  'ONLOADCHECKLISTRUNSSUCCEEDED'
);

export const onRemoveChecklistRun = createAction('ON_REMOVE_CHECKLIST_RUN');

export const selectChecklist = createAction('SELECTCHECKLIST');
export const selectChecklistResult = createAction('SELECTCHECKLISTRESULT');

export const selectChecklistRun = createAction('SELECTCHECKLISTRUN');

export const onFinishChecklistRun = createAction('FINISH_CHECKLIST_RUN');
export const onRestartChecklist = createAction('RESTART_CHECKLIST');
export const onRetryChecklist = createAction('RETRY_CHECKLIST');
export const onOpenCompletedDialog = createAction('COMPLETED_DIALOG_OPEN');
export const onCloseCompletedDialog = createAction('COMPLETED_DIALOG_CLOSE');

export const onLoadChecklistToDos = createAction('ON_LOAD_CHECKLISTTODOS');
export const onLoadChecklistToDosSucceeded = createAction(
  'ON_LOAD_CHECKLISTTODOS_SUCCESS'
);
export const onLoadChecklistToDosFailed = createAction(
  'ON_LOAD_CHECKLISTTODOS_FAILED'
);
export const onLoadChecklistDueDates = createAction(
  'ON_LOAD_CHECKLISTDUEDATES'
);
export const onLoadChecklistDueDatesSucceeded = createAction(
  'ON_LOAD_CHECKLISTDUEDATES_SUCCESS'
);
export const onLoadChecklistDueDatesFailed = createAction(
  'ON_LOAD_CHECKLISTDUEDATES_FAILED'
);

export const onLoadChecklist = createAction('ON_LOAD_CHECKLIST');
export const onLoadChecklistSucceeded = createAction(
  'ON_LOAD_CHECKLIST_SUCCESS'
);

//load single checklistRun and update selectedChecklistRun
export const onLoadChecklistRun = createAction('ON_LOAD_CHECKLIST_RUN');
export const onLoadChecklistRunSucceeded = createAction('ON_LOAD_CHECKLIST_RUN_SUCCESS');
export const onLoadChecklistRunFailed = createAction('ON_LOAD_CHECKLIST_RUN_FAILED');
export const onLoadChecklistFailed = createAction('ONLOADCHECKLISTFAILED');

export const onSearchChecklist = createAction('searchChecklistAction');
export const onSearchChecklistSucceeded = createAction(
  'searchChecklistSucceeded'
);
export const onSearchChecklistFailed = createAction('searchChecklistFailed');

export const onExportChecklistContent = createAction(
  'onExportChecklistContent'
);
export const onExportChecklistContentFailed = createAction(
  'onExportChecklistContentFailed'
);
export const onExportChecklistContentSucceeded = createAction(
  'onExportContentSucceeded'
);

export const onStartChecklist = createAction('ON_START_CHECKLIST');
export const onStartChecklistSucceeded = createAction(
  'ON_START_CHECKLIST_SUCCESS'
);
export const onSubmitChecklistSucceeded = createAction(
  'ON_SUBMIT_Checklist_SUCCEEDED_ACTION'
);

export const onSubmitChecklist = createAction('ON_SUBMIT_CHECKLIST');

export const loadDefaultBulletinBoard = createAction(
  'loadDefaultBulletinBoardAction'
);
export const loadDefaultBulletinBoardSucceeded = createAction(
  'loadDefaultBulltingBoardSuccessAction'
);
export const getPinnedContentAction = createAction('getPinnedContentAction');
export const getPinnedContentSuccessAction = createAction(
  'getPinnedContentSuccessAction'
);
export const getPinnedContentFailedAction = createAction(
  'getPinnedContentFailedAction'
);
export const pinOrUnpinContentAction = createAction('pinOrUnpinContentAction');
export const pinOrUnpinContentSuccessAction = createAction(
  'pinOrUnpinContentSuccess'
);
export const selectChecklistToDo = createAction('SELECT_CHECKLISTTODO');
export const onUpdateScore = createAction('ON_UPDATE_SCORE');

const findChecklist = (checklistList, id) => {
  for (let i = checklistList.length - 1; i >= 0; i--) {
    const checklist = checklistList[i];

    if (checklist.type == 'checklist' && checklist.id == id) {
      return checklist;
    }

    if (checklist.type == 'checklistGroup' && checklist.children) {
      for (let j = checklist.children.length - 1; j >= 0; j--) {
        if (
          checklist.children[j].type == 'checklist' &&
          checklist.children[j].id == id
        ) {
          return checklist.children[j];
        }
      }
    }
  }
};

const removeChecklistRun = (state, checklistRunId) =>
  state.merge({
    checklistRuns: state.checklistRuns.filter((r) => r.id !== checklistRunId),
  });

const loadChecklistRuns = (state) =>
  state.merge({
    checklistRuns: state.checklistRuns,
  });

const excludeFromList = (checklistList, id) => {
  const checklists = checklistList
    .asMutable({ deep: true })
    .filter(
      (c) =>
        c.type === 'checklistGroup' || (c.type === 'checklist' && c.id !== id)
    );

  for (let i = checklists.length - 1; i >= 0; i--) {
    const c = checklists[i];
    if (c.type === 'checklistGroup' && c.children) {
      checklists[i].children = checklists[i].children.filter(
        (f) => f.type === 'checklist' && f.id !== id
      );
    }
  }

  return checklists;
};

const getUpdatedChecklistList = (checklistList, checklist, id) => {
  const checklists = checklistList.asMutable({ deep: true });

  for (let i = checklists.length - 1; i >= 0; i--) {
    const c = checklists[i];

    if (c.type === 'checklist' && c.id === id) {
      c[i] = checklist;
    }

    if (c.type === 'checklistGroup' && c.children) {
      for (let j = c.children.length - 1; j >= 0; j--) {
        if (c.children[j].type === 'checklist' && c.children[j].id === id) {
          checklists[i].children[j] = checklist;
        }
      }
    }
  }
  return checklists;
};

const getRandomChecklists = (groupTree, exclude) => {
  let checklists = [];

  if (!groupTree) {
    return [];
  }

  groupTree.forEach((t) => {
    if (t.type === 'checklistGroup' && t.children) {
      checklists = checklists.concat(t.children);
    }
  });

  checklists = checklists.concat(
    groupTree.filter((c) => c.type == 'checklist')
  );
  checklists = checklists.filter((c) => !exclude || c.id != exclude.id);

  return getRandom(checklists, Math.min(3, checklists.length - 1));
};

const restart = (state) => {
  return state.merge({
    checklistRunStartedAt: new Date().toISOString(),
    completedDialogOpen: false,
  });
};

const retry = (state) => {
  return state.merge({
    completedDialogOpen: false,
    checklistRunStartedAt: new Date().toISOString(),
  });
};

const handleChecklistPinning = (state, dto) => {
  const checklist = findChecklist(state.checklists, dto.contentId);
  const newChecklist = checklist.asMutable();
  newChecklist.isPinned = !checklist.isPinned;

  const bulletinBoardContent = newChecklist.isPinned
    ? getUpdatedChecklistList(
        state.bulletinBoardContent,
        newChecklist,
        dto.contentId
      )
    : excludeFromList(state.bulletinBoardContent, newChecklist.id);

  return state.merge({
    checklists: getUpdatedChecklistList(
      state.checklists,
      newChecklist,
      dto.contentId
    ),
    bulletinBoardContent,
  });
};

const selectChecklistToDoReducer = (state, checklist) => {
  const selectedChecklistToDo = state.checklistToDos.find(
    (e) => e.checklist.id == checklist.id
  );

  if (!selectedChecklistToDo) return state;

  const checklistRun = state.checklistRuns.find(
    (r) => r.checklistId == selectedChecklistToDo.checklist.id
  );

  return state.merge({
    selectedChecklistToDo,
    selectedChecklist: selectedChecklistToDo.checklist,
    selectedChecklistId: selectedChecklistToDo.checklist.id * 1,
    isLoadingChecklistitems: true,
    checklistRun,
  });
};

const selectChecklistReducer = (state, checklist) => {
  let selectedChecklist = state.checklists.find((e) => e.id == checklist.id);
  if (selectedChecklist === undefined) {
    state.checklists.forEach((c) => {
      if (c.children != undefined) {
        selectedChecklist = c.children.find((e) => e.id === checklist.id);
      }
    });
  }
  let selectedChecklistRun = state.checklistRuns.filter(
    (r) => r.checklistId == checklist.id
  );
  if (selectedChecklistRun.length > 1) {
    selectedChecklistRun = selectedChecklistRun.reduce((a, b) =>
      a.startDate > b.startDate ? a : b
    );
  }
  if (Array.isArray(selectedChecklistRun)) {
    selectedChecklistRun = selectedChecklistRun[0];
  }

  return state.merge({
    selectedChecklist: selectedChecklist,
    selectedChecklistId: checklist.id,
    isLoadingChecklistItems: true,
    selectedChecklistRun: selectedChecklistRun,
    score: 0,
  });
};

const selectChecklistRunReducer = (state, { checklist, checklistRun }) => {
  return state.merge({
    selectedChecklistRun: checklistRun,
    selectedChecklistId: checklist.id,
    isLoadingChecklistItems: true,
    selectedChecklist: checklist,
  });
};

const selectChecklistResultReducer = (state, checklist) => {
  const selectedChecklist = findChecklist(state.results, checklist.id);

  return state.merge({
    selectedChecklist,
    selectedChecklistId: checklist.id * 1,
    isLoadingChecklistItems: true,
  });
};

const startChecklistSuccess = (state, checklistRun) => {
  const checklistRuns = state.checklistRuns.asMutable();
  checklistRuns.push(checklistRun);
  return state.merge({
    selectedChecklistToDo: null,
    checklistRuns,
    checklistRun,
  });
};

const handlePinningAction = (state, dto) => {
  if (dto && dto.contentType && dto.contentType == 'checklist') {
    return handleChecklistPinning(state, dto);
  }

  return state;
};

const reducers = createReducer(
  {
    [onLoadChecklists]: (state) => state.merge({ isLoading: true }),
    [onLoadChecklistRuns]: (state) => state.merge({ isLoading: true }),
    [onSearchChecklistSucceeded]: (state, result) =>
      state.merge({
        searchResults: result,
        isLoadingSearchResults: false,
      }),
    [onLoadChecklist]: (state) => state.merge({ isLoading: true }),
    [onLoadChecklistSucceeded]: (state, checklist) =>
      state.merge({
        selectedChecklist: checklist,
        isLoading: false,
      }),
    [onLoadChecklistRun]: (state) => state.merge({ isLoading: true }),
    [onRemoveChecklistRun]: removeChecklistRun,
    [selectChecklist]: selectChecklistReducer,
    [selectChecklistRun]: selectChecklistRunReducer,
    [onSubmitChecklist]: (state) => state.merge({ completedDialogOpen: true }),
    [selectChecklistResult]: selectChecklistResultReducer,
    [onSearchChecklistFailed]: (state) =>
      state.merge({ isLoadingSearchResults: false }),
    [onSearchChecklist]: (state, searchTerm) =>
      state.merge({
        searchTerm,
        isLoadingSearchResults: true,
      }),
    [selectChecklistToDo]: selectChecklistToDoReducer,
    [onLoadChecklistsSucceeded]: (state, { checklists }) => {
      let selectedChecklist = state.selectedChecklist;
      if (state.selectedChecklistId != 0) {
        selectedChecklist = checklists.find(
          (x) => x.id == state.selectedChecklistId
        );
      }

      const newState = state.merge({
        checklists,
        selectedChecklist,
        previewChecklists: getRandomChecklists(
          checklists,
          state.selectedChecklist
        ),
        isLoading: false,
      });

      return newState.merge({
        selectedChecklist:
          findChecklist(newState.checklists, newState.selectedChecklistId) ||
          newState.selectedChecklist,
      });
    },
    [onLoadChecklistRunsSucceeded]: (state, { checklistRuns }) => {
      const newState = state.merge({
        checklistRuns,
        isLoading: false,
      });
      return newState;
    },
    [onLoadChecklistRunSucceeded]: (state, { checklistRun }) => {
      const newState = state.merge({
        selectedChecklistRun: checklistRun,
        isLoading: false,
      });
      return newState;
    },
    [onLoadChecklistRunsFailed]: (state) => state.merge({ isLoading: false }),
    [onStartChecklistSucceeded]: startChecklistSuccess,
    [onRestartChecklist]: restart,
    [onRetryChecklist]: retry,
    [pinOrUnpinContentSuccessAction]: handlePinningAction,
    [onOpenCompletedDialog]: (state) =>
      state.merge({ completedDialogOpen: true }),
    [onCloseCompletedDialog]: (state) =>
      state.merge({ completedDialogOpen: false }),

    [getPinnedContentSuccessAction]: (state, bulletinBoardContent) =>
      state.merge({
        bulletinBoardContent,
      }),
    [loadDefaultBulletinBoardSucceeded]: (state, bulletinBoard) =>
      state.merge({
        bulletinBoard,
      }),
    [onLoadChecklistToDos]: (state) =>
      state.merge({ isLoadingChecklistToDosChecklists: true }),
    [onLoadChecklistToDosSucceeded]: (state, checklistToDos) =>
      state.merge({ checklistToDos, isLoadingChecklistToDoChecklists: false }),
    [onLoadChecklistToDosFailed]: (state) =>
      state.merge({ isLoadingChecklistToDoChecklists: false }),
    [onLoadChecklistFailed]: (state) => state.merge({ isLoading: false }),
    [onLoadChecklistDueDates]: (state) => state.merge({ isLoading: true }),
    [onLoadChecklistDueDatesSucceeded]: (state, { checklistDueDates }) => {
      const dueChecklists = state.checklists.filter((c) => {
        return state.checklistToDos.some((element) => {
          return element.checklistId === c.id;
        });
      });
      return state.merge({
        checklistDueDates,
        dueChecklists: dueChecklists,
        isLoading: false,
      });
    },
    [onLoadChecklistDueDatesFailed]: (state) =>
      state.merge({ isLoadings: false }),
    [onUpdateScore]: (state, checked) => {
      if (!state.score) {
        if (checked) {
          return state.merge({
            score: 1,
          });
        }
        return state.merge({
          score: 0,
        });
      }
      if (checked) {
        return state.merge({
          score: state.score + 1,
        });
      }
      return state.merge({
        score: state.score - 1,
      });
    },
  },
  INITIAL_STATE
);

export default reducers;



// WEBPACK FOOTER //
// ./src/app/reducers/checklist.reducers.js